import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const ReferralSourcePage = () => {
  const columns = [
    { key: 'name', label: 'Referral Source Name' },
    { key: 'type', label: 'Type' },
    { key: 'contact', label: 'Contact Person' },
    { key: 'phone', label: 'Phone' },
    { key: 'fax', label: 'Fax' },
    { key: 'address', label: 'Address' },
    { key: 'active', label: 'Active' },
  ];

  const initialData = [
    { id: '1', name: 'Memorial Hermann Hospital', type: 'Hospital', contact: 'Jane Smith', phone: '(713) 555-5001', fax: '(713) 555-5002', address: '6411 Fannin St, Houston TX', active: 'Yes' },
    { id: '2', name: 'Houston Methodist', type: 'Hospital', contact: 'John Doe', phone: '(713) 555-6001', fax: '(713) 555-6002', address: '6565 Fannin St, Houston TX', active: 'Yes' },
    { id: '3', name: 'Dr. Williams Office', type: 'Physician', contact: 'Dr. James Williams', phone: '(713) 555-1001', fax: '(713) 555-1002', address: '123 Medical Center Dr', active: 'Yes' },
    { id: '4', name: 'Senior Care Center', type: 'SNF', contact: 'Mary Johnson', phone: '(713) 555-7001', fax: '(713) 555-7002', address: '1000 Senior Care Ln', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="Referral Source"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Source"
    />
  );
};

export default ReferralSourcePage;
